import { render, staticRenderFns } from "./ConfigLogsIntegracao.vue?vue&type=template&id=48e8069d&scoped=true&lang=pug&"
import script from "./ConfigLogsIntegracao.vue?vue&type=script&lang=js&"
export * from "./ConfigLogsIntegracao.vue?vue&type=script&lang=js&"
import style0 from "./ConfigLogsIntegracao.vue?vue&type=style&index=0&id=48e8069d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e8069d",
  null
  
)

export default component.exports